/* ACS 2026-10-11 (Claude refresh): product page helpers. Loaded by snippets/acs-product-parts.liquid.
   (1) After a variant change, copy the server-rendered stock line ([data-acs-live]) from the section HTML the theme
       already fetched (PUB_SUB_EVENTS.variantChange). (2) Phone only: a sticky "Add to cart · $X" bar that appears once
       the real Add to cart button has scrolled up out of view (never while that button is disabled); it only clicks the
       real button, so the cart, Shop Pay and analytics behave exactly as before. Without this file the page works the same. No fetches, no tracking. */
(function () {
  'use strict';
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    var mark = document.querySelector('.acs-pdp-mark');
    if (!mark) return;
    var product = mark.closest('.product');
    if (!product) return;

    // (1) Live stock line
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
          try {
            var html = ev && ev.data && ev.data.html;
            if (!html || !html.querySelectorAll) return;
            html.querySelectorAll('[data-acs-live][id]').forEach(function (fresh) {
              var cur = document.getElementById(fresh.id);
              if (cur) { cur.innerHTML = fresh.innerHTML; cur.className = fresh.className; }
            });
            updateBar();
          } catch (e) {}
        });
      }
    } catch (e) {}

    // (2) Phone sticky bar
    var real = product.querySelector('.product-form__submit');
    var bar = null, btn = null, visible = true;
    function priceText() {
      var price = product.querySelector('.product__info-container .price');
      if (!price) return '';
      var el = price.classList.contains('price--on-sale') ? price.querySelector('.price__sale .price-item--last') : price.querySelector('.price__regular .price-item--regular');
      return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
    }
    function updateBar() {
      if (!bar) return;
      real = product.querySelector('.product-form__submit') || real;
      var disabled = real.hasAttribute('disabled') || real.getAttribute('aria-disabled') === 'true';
      var p = priceText();
      btn.disabled = disabled;
      btn.textContent = disabled ? 'Sold out' : ('Add to cart' + (p ? ' · ' + p : ''));
      show();
    }
    function show() {
      if (!bar) return;
      // never a dead bar: kept hidden while the real button is disabled (sold out / unavailable variant)
      var on = !visible && !btn.disabled && window.matchMedia('(max-width: 749px)').matches;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      btn.tabIndex = on ? 0 : -1;
    }
    try {
      if (real) {
        var titleEl = product.querySelector('.product__title h1');
        bar = document.createElement('div');
        bar.className = 'acs-pdp-bar';
        bar.setAttribute('aria-hidden', 'true');
        var t = document.createElement('span');
        t.className = 'acs-pdp-bar__title';
        t.textContent = titleEl ? titleEl.textContent.trim() : '';
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'acs-pdp-bar__btn';
        btn.tabIndex = -1;
        btn.addEventListener('click', function () {
          var b = product.querySelector('.product-form__submit') || real;
          if (b.hasAttribute('disabled')) return;
          b.click();
        });
        bar.appendChild(t);
        bar.appendChild(btn);
        document.body.appendChild(bar);
        updateBar();
        // shown only after the real button has gone up off the screen (not before the reader reaches it)
        var ticking = false;
        var check = function () {
          ticking = false;
          var b = product.querySelector('.product-form__submit') || real;
          visible = b.getBoundingClientRect().bottom > 0;
          show();
        };
        window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
        check();
        new MutationObserver(updateBar).observe(real, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });
        window.addEventListener('resize', check, { passive: true });
      }
    } catch (e) { if (bar && bar.parentNode) bar.parentNode.removeChild(bar); }
  });
})();
